module.exports = __webpack_public_path__ + "img/service-252.eb855ed4.png";